import {isFeatureEnabled} from 'feature-flags';
import {closeCurrentDialog, openDialog} from 'platform/components';

import {featureFlags} from '@dms/feature-flags';

import {ActivityChangeLog, ActivityChangeLogProps} from '../components/ActivityChangeLog';

export function openActivityChangeLog(props: ActivityChangeLogProps) {
  if (isFeatureEnabled(featureFlags.VERSION_LOG_DUMP)) {
    openDialog(<ActivityChangeLog {...props} />, {
      id: 'changeLogModal',
      title: 'Changes',
      size: 'large',
      buttons: [{title: 'Close', variant: 'secondary', onClick: closeCurrentDialog}],
    });
  }
}
